import { useQuery } from '@tanstack/react-query';

import type { SabaDashboard } from 'lib/saba/dashboard';

export default function useDashboard() {
  return useQuery<SabaDashboard>({
    queryKey: [ 'saba:dashboard' ],
    queryFn: async({ signal }) => {
      const response = await fetch('/node-api/saba-dashboard', { signal });
      if (!response.ok) throw new Error('دریافت آمار شبکه ناموفق بود');
      return response.json() as Promise<SabaDashboard>;
    },
    staleTime: 30_000,
    refetchInterval: 30_000,
    retry: 1,
  });
}
